import { render, staticRenderFns } from "./ConfigurationSettingsList.vue?vue&type=template&id=1fb2e311"
import script from "./ConfigurationSettingsList.vue?vue&type=script&lang=js"
export * from "./ConfigurationSettingsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports